import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const FullWindowContainer = styled(Box)`
  align-items: center;
  background-color: ${colors.background.primaryBackground};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
`

export const Header = styled(Box)`
  align-items: center;
  background: ${colors.interactive.primaryEnabled};
  display: flex;
  justify-content: space-between;
  min-height: 70px;
  padding: 0 24px;
  width: 100%;
`

export const SurveyContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  height: 100%;
  width: 100%;
`

export const WizardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
`

export const WizardSteps = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 40px;
  position: relative;
  width: 768px;
`

export const StepContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled(Typography)`
  ${typography.up2.regularSerif};
`

export const Description = styled(Typography)`
  ${typography.baseline.regularSans};
`

export const Image = styled.img`
  max-width: 50%;
`

export const ImageContainer = styled(Box)`
  display: flex;
  justify-content: center;
`

export const SubActionHeader = styled(Typography)`
  ${typography.up1.semiBoldSans};
`

export const SelectorActions = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
`

export const BackButton = styled(Box)`
  display: flex;
  justify-content: center;
`
